import React from 'react';
import cookie from 'cookie';
import { connect } from 'react-redux';
import smoothscroll from 'smoothscroll-polyfill';

import { createAuthenticatedApiInstance } from 'src/utils/api';
import { setReferrerCookie } from 'src/utils/cookie';
import { handleQueryParams } from 'src/modules/shared/modal/actions';
import { fetchUnreadMessagesCount, fetchUnreadNotificationsCount, fetchCurrentUser, fetchPermissions } from 'src/modules/shared/context/actions';
import { unsetServerSession } from 'src/modules/shared/auth/actions';
import { showDFPModal } from 'src/modules/shared/modal/actions';
import { init as initWebsockets } from 'src/modules/websockets/initWebsockets';
import { setSession } from 'src/utils/session';
import { isUserBot } from 'src/utils/seo';
import { enableFlag, disableFlag } from 'src/utils/featureFlag';

const isServer = typeof window === 'undefined';

const WithSession = (Child) => {
  return class WrappedComponent extends React.Component {
    static defaultProps = {
      queryParams: {},
    };

    static async getInitialProps(context) {
      const { req, res, store: { dispatch, getState }, query } = context;

      if (query.featureflag) dispatch(enableFlag());

      if (req) { // server
        const { huSessID: sessionId } = cookie.parse(req.headers.cookie || '');

        if (!isUserBot) {
          await setSession(sessionId, res, dispatch);
        }

        // only fetch user info for logged in user
        if (sessionId && !sessionId.endsWith(':00000000-0000-0000-0000-000000000000')) {
          await dispatch(fetchCurrentUser());
        }
      }

      let state = getState();

      // create an authenticated api instance for this request
      const api = createAuthenticatedApiInstance(getState);

      // pass the current user to the child's getInitialProps so it can make use of it
      const childInitialProps = await Child.getInitialProps({
        ...context,
        api,
        currentUser: state.context.currentUser,
      });

      // this is wildly annoying, but withsession appears to rely on certain
      // redux actions being dispatched by the getInitialProps implementation
      // of individual pages, so we have to get the state again here to make
      // sure we have up to date state.
      state = getState();

      if (state.context.currentUser) {
        const communityId = state.context.currentCommunity && state.context.currentCommunity.communityId;
        await dispatch(fetchPermissions(communityId));
        state = getState();
      }

      if (res) {
        dispatch(unsetServerSession());
      }

      return {
        queryParams: query,
        isLoggedIn: !!state.context.currentUser,
        currentUser: state.context.currentUser,
        community: state.context.currentCommunity,
        namespacesRequired: ['common'],
        ...childInitialProps,
      };
    }

    componentDidMount = async () => {
      const { dispatch, queryParams, isLoggedIn } = this.props;

      if (!isServer) {

        setReferrerCookie(document.referrer);
        dispatch(handleQueryParams(queryParams));

        if (isLoggedIn) {
          dispatch(fetchUnreadMessagesCount());
          dispatch(fetchUnreadNotificationsCount());
          initWebsockets(dispatch);
        }

        // For Google Ad Manager adverts
        window.triggerDFPPopup = (content) => {
          dispatch(showDFPModal(content));
        };

        window.enableFlag = () => {
          dispatch(enableFlag());
        };

        window.disableFlag = () => {
          dispatch(disableFlag());
        };
      }

      smoothscroll.polyfill();
    }

    render() {
      return (
        <Child {...this.props} />
      );
    }
  };
};

const WithSessionHoc = (child) => connect(null)(WithSession(child));
export default WithSessionHoc;
